import { useSnapshot } from 'valtio';

import { getDefaultLocale } from '@canvas/constants';
import { type Identity } from '@canvas/model/identity';

import { currentUserState } from './user';

/**
 * Hook to return the user's locale as snapshotted from valtio from identity
 * if it has been successfully loaded, or the fallback locale {@link getDefaultLocale}
 *
 * @returns The user's locale from identity if it exists, or {@link getDefaultLocale} otherwise
 */
export const useUserLocale = () => {
  const userState = useSnapshot(currentUserState);

  if (userState.status !== 'succeeded') {
    return getDefaultLocale();
  }

  return getLocaleFromIdentity(userState.identity);
};

export const getLocaleFromIdentity = (
  identity: Identity | Readonly<Identity>
): string => {
  return identity.locale ?? getDefaultLocale();
};
